
import speedkitHydrate from '#speedkit/hydrate'
import SpeedKitMessage from "~/components/SpeedKitMessage.vue";
export default {
  components: {
    SpeedKitMessage,
    Cookies: speedkitHydrate(() => import('@/components/global/Cookies.vue')),
    HeaderBar: speedkitHydrate(() => import('@/components/HeaderBar.vue')),
    FooterSection: speedkitHydrate(() => import('@/components/FooterSection.vue')),
  },
}
